var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAiSparkleSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M.25 0h13v13h-13z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M7.303 5.295c-.494-.56-.926-1.48-1.245-2.258a.13.13 0 0 0-.065 0c-.318.778-.75 1.698-1.245 2.257-.494.56-1.307 1.05-1.994 1.41a.2.2 0 0 0 0 .075c.687.36 1.5.85 1.994 1.409.495.56.927 1.48 1.245 2.257a.13.13 0 0 0 .065 0c.319-.777.75-1.697 1.245-2.257m0 0c.493-.557 1.28-1.051 1.944-1.416a.2.2 0 0 0 0-.061c-.664-.365-1.451-.86-1.944-1.416M10.05 3.313c-.178-.201-.333-.532-.448-.812a.1.1 0 0 0-.023 0c-.114.28-.27.61-.448.812-.177.201-.47.377-.717.507a.1.1 0 0 0 0 .027c.247.13.54.305.717.507.178.2.334.532.448.811a.04.04 0 0 0 .023 0c.115-.28.27-.61.448-.811m0 0c.177-.2.46-.378.7-.51a.1.1 0 0 0 0-.022c-.24-.131-.523-.309-.7-.509",
  clipRule: "evenodd"
})));
export default SvgAiSparkleSmall;